import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../lib/seo";
import { Squiggle, Star, Cloud } from "../components/Doodles";

export default function NotFound() {
  useSEO({ title: "Page not found — Haven Hives", description: "This page has flown away." });
  return (
    <div className="max-w-xl mx-auto text-center py-24 px-5 relative" data-testid="not-found-page">
      <Cloud className="w-14 h-14 mx-auto text-sky" />
      <p className="font-display font-semibold text-7xl mt-4 text-forest">404</p>
      <h1 className="font-display font-semibold text-2xl mt-2">This page buzzed off somewhere</h1>
      <p className="text-charcoal/70 mt-3">The link may be old or mistyped. The hive is still full of joyful things, though.</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
        <Link to="/" data-testid="not-found-home" className="bg-forest text-white hover:bg-forest-dark px-6 py-3 rounded-full">Back to the hive</Link>
        <Link to="/collections/shop-all" className="border border-charcoal/20 font-semibold px-6 py-3 rounded-full">Browse the shop</Link>
      </div>
      <Squiggle className="w-32 mx-auto mt-8 text-forest/40" />
    </div>
  );
}
